/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Optional } from '@angular/core';
import { AuthLog } from './shared-auth-logs/auth-log.model';
import {
  AbstractResourceService,
  JsonApiListResourceMetadataBase,
  UrlBuilderService,
} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/index';

@Injectable()
export class AuthLogsService extends AbstractResourceService<
  AuthLog,
  AuthLog,
  JsonApiListResourceMetadataBase,
  JsonApiListResourceMetadataBase
> {
  authLogsUrl = '/api/auth/authLogs';

  constructor(private http: HttpClient, @Optional() private environmentService: EnvironmentService) {
    super(
      http,
      environmentService.getEnvironmentProperty('authLogsUrl'),
      AuthLog,
      AuthLog,
      JsonApiListResourceMetadataBase
    );

    if (this.environmentService && this.environmentService.getEnvironmentProperty('authLogsUrl')) {
      this.authLogsUrl = `${ this.environmentService.getEnvironmentProperty('authLogsUrl')}`;
    }
  }

  getAuthLogs(event: any): Observable<AuthLog[]> {
    return <Observable<AuthLog[]>>this.http.get(UrlBuilderService.createUrlFromLazyLoadEvent(this.authLogsUrl, event));
  }
}
